import { render, staticRenderFns } from "./EmprestimoGrid.vue?vue&type=template&id=07084204"
import script from "./EmprestimoGrid.vue?vue&type=script&lang=js"
export * from "./EmprestimoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports